import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import Auth from "../../auth/Auth";
import { IStore } from "../../models/IStore";

export interface ICallbackSamlProdAsiaProps extends RouteComponentProps {
  auth: Auth;
}

export class CallbackSamlProdAsia extends React.Component<
  ICallbackSamlProdAsiaProps
> {
    public constructor(props: ICallbackSamlProdAsiaProps) {
    super(props);
  }

  public componentDidMount() {
    const { auth } = this.props;

    auth.loginSAMLProdAsia().then(() => {
      console.log("Login via SAML Prod Asia");
    });
  }

  public render() {
    return <div>Loading...</div>;
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    auth: state.auth0
  };
};

export default connect(mapStateToProps)(CallbackSamlProdAsia);
